import React, { useState, useEffect, useRef } from "react";

export const NavbarDropdownHeader = ({ children }) => {
	return <>{children}</>;
};

export const NavbarDropdownBody = ({ children }) => {
	return <div className="dropdownMenu">{children}</div>;
};

function getHeaderAndBody(children) {
	let res = {
		header: null,
		body: null,
	};

	{
		React.Children.map(children, child => {
			if (child.type === NavbarDropdownHeader) {
				res.header = child;
			}

			if (child.type === NavbarDropdownBody) {
				res.body = child;
			}
		});
	}

	return res;
}

const NavbarDropdown = ({ children, className }) => {
	const [open, setOpen] = useState(false);
	const node = useRef();

	const parts = getHeaderAndBody(children);

	//https://codesandbox.io/s/9o3lw5792w
	const handleClickOutside = e => {
		//@ts-ignore
		if (node.current.contains(e.target)) {
			// inside click
			return;
		}
		setOpen(false);
	};

	useEffect(() => {
		//@ts-ignore
		if (open !== null) {
			document.addEventListener("mousedown", handleClickOutside);
		} else {
			document.removeEventListener("mousedown", handleClickOutside);
		}

		return () => {
			document.removeEventListener("mousedown", handleClickOutside);
		};
	}, [open]);

	return (
		<div
			className={className}
			onClick={() => {
				setOpen(!open);
			}}
			ref={node}
		>
			{parts.header}
			{open ? parts.body : null}
		</div>
	);
};

export default NavbarDropdown;
